import { render, staticRenderFns } from "./MyCart.vue?vue&type=template&id=d52619a0&scoped=true&"
import script from "./MyCart.vue?vue&type=script&lang=js&"
export * from "./MyCart.vue?vue&type=script&lang=js&"
import style0 from "./MyCart.vue?vue&type=style&index=0&id=d52619a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52619a0",
  null
  
)

export default component.exports